export enum Datasources {
  Vzo = 'signs.vzo',
  VzoAcceptance = 'signs.vzo_acceptance',
}
